import React from 'react';
import R from 'ramda';
import { SelectButton } from '../../app/components';
import './styles.css';

const TypeFilter = ({ types, onSelectType, onDeselectType }) => (
  <div className="type-filter">
    <h2>Tegund</h2>
    <div className="types">
      <SelectButton
        content={<div><span className="icon-house-icon" /><p>Hús</p></div>}
        selected={R.contains('house', types)}
        disabled={false}
        onClick={e => R.contains('house', types) ? onDeselectType(e, 'house') : onSelectType(e, 'house')}
      />
      <SelectButton
        content={<div><span className="icon-apt-icon" /><p>Íbúð</p></div>}
        selected={R.contains('apartment', types)}
        disabled={false}
        onClick={e => R.contains('apartment', types) ? onDeselectType(e, 'apartment') : onSelectType(e, 'apartment')}
      />
      <SelectButton
        content={<div><span className="icon-room-icon" /><p>Herbergi</p></div>}
        selected={R.contains('room', types)}
        disabled={false}
        onClick={e => R.contains('room', types) ? onDeselectType(e, 'room') : onSelectType(e, 'room')}
      />
      <SelectButton
        content={<div><span className="icon-commercial-icon" /><p>Atvinnu-<br />húsnæði</p></div>}
        selected={R.contains('commercial', types)}
        disabled={false}
        onClick={e => R.contains('commercial', types) ? onDeselectType(e, 'commercial') : onSelectType(e, 'commercial')}
      />
    </div>
  </div>
);

TypeFilter.propTypes = {
  types: React.PropTypes.array.isRequired,
  onSelectType: React.PropTypes.func.isRequired,
  onDeselectType: React.PropTypes.func.isRequired,
};

export default TypeFilter;



// WEBPACK FOOTER //
// ./src/browser/filters/TypeFilter/TypeFilter.js